import { render, staticRenderFns } from "./AnswerComment.vue?vue&type=template&id=5bd9bb08&scoped=true&"
import script from "./AnswerComment.vue?vue&type=script&lang=js&"
export * from "./AnswerComment.vue?vue&type=script&lang=js&"
import style0 from "./AnswerComment.vue?vue&type=style&index=0&id=5bd9bb08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd9bb08",
  null
  
)

export default component.exports